import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminTraffic from "@/pages/admin/AdminTraffic";
import { adminHead } from "@/lib/route-seo";

export const Route = createFileRoute("/admin/traffic")({
  head: () => adminHead("Traffic Analytics | Admin", "Traffic analytics dashboard.", "/admin/traffic"),
  component: () => (
    <ProtectedRoute>
      <AdminTraffic />
    </ProtectedRoute>
  ),
});
